import React from 'react';
import './CartPanel.css';
import { useCart } from '../../context/CartContext';
import Button from '../UI/Button';

const CartPanel = ({ setRoute }) => {
  const {
    cart,
    isCartOpen,
    closeCart,
    updateQuantity,
    removeFromCart,
    getCartTotal,
    clearCart,
  } = useCart();

  if (!isCartOpen) return null;

  const handleCheckout = () => {
    if (cart.length === 0) {
      alert('Your cart is empty!');
      return;
    }
    
    // Close cart and navigate to checkout
    closeCart();
    if (setRoute) {
      setRoute('checkout');
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="cart-backdrop"
        onClick={closeCart}
        aria-hidden="true"
      />

      {/* Cart Panel */}
      <aside
        className="cart-panel"
        role="dialog"
        aria-label="Shopping cart"
        aria-modal="true"
      >
        <div className="cart-header">
          <h2>Your Cart</h2>
          <button
            className="cart-close"
            onClick={closeCart}
            aria-label="Close cart"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="cart-body">
          {cart.length === 0 ? (
            <div className="cart-empty">
              <i className="fas fa-shopping-cart empty-icon"></i>
              <p>Your cart is empty</p>
              <Button
                variant="primary"
                onClick={closeCart}
              >
                Continue Shopping
              </Button>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cart.map((item) => (
                  <div key={item.id} className="cart-item">
                    <img
                      src={item.labelImage || item.image}
                      alt={item.name}
                      className="cart-item-image"
                      onError={(e) => {
                        // Fallback to main product image if label image fails
                        if (e.target.src !== item.image) {
                          e.target.src = item.image;
                        }
                      }}
                    />
                    <div className="cart-item-info">
                      <h3 className="cart-item-name">{item.name}</h3>
                      <p className="cart-item-price">${item.price.toFixed(2)}</p>

                      <div className="cart-item-actions">
                        <div className="cart-quantity-selector">
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            aria-label="Decrease quantity"
                            className="qty-btn"
                          >
                            <i className="fas fa-minus"></i>
                          </button>
                          <span className="quantity">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            aria-label="Increase quantity"
                            className="qty-btn"
                          >
                            <i className="fas fa-plus"></i>
                          </button>
                        </div>

                        <button
                          className="remove-btn"
                          onClick={() => removeFromCart(item.id)}
                          aria-label={`Remove ${item.name} from cart`}
                        >
                          <i className="fas fa-trash"></i>
                          Remove
                        </button>
                      </div>
                    </div>
                    <div className="cart-item-subtotal">
                      ${(item.price * item.quantity).toFixed(2)}
                    </div>
                  </div>
                ))}
              </div>

              <div className="cart-footer">
                <div className="cart-total">
                  <span className="total-label">Total:</span>
                  <span className="total-amount">${getCartTotal().toFixed(2)}</span>
                </div>

                <Button
                  variant="primary"
                  size="lg"
                  onClick={handleCheckout}
                  className="checkout-btn"
                  icon={<i className="fas fa-lock"></i>}
                >
                  Secure Checkout
                </Button>

                <button
                  className="clear-cart-btn"
                  onClick={clearCart}
                >
                  Clear Cart
                </button>
              </div>
            </>
          )}
        </div>
      </aside>
    </>
  );
};

export default CartPanel;
